/**
 * Filters unique values based on mapper function
 * @param {Array} array
 * @param {Function} mapper Function which acts as identity for each element
 * @return {Array} array with unique values (filtered based on mapped values)
 */

export const unique = (arr, mapper = e => e.id) =>
  arr.filter((e, i) => arr.findIndex(x => mapper(x) == mapper(e)) == i)

/**
 * Merges two arrays (keeping only unique values based on mapper function)
 * @param {Array} arrays Array of arrays
 * @param {Function} mapper Function which acts as identity for each element
 * @return {Array} flattened array with unique values (based on mapper)
 */

export const mergeArrays = (arrays, mapper = e => e.id) => unique(arrays.flat(), mapper)
